//@flow
import * as React from 'react';
import { withRouter } from 'common/components/core/router';
import { createEntityImportContainer } from 'common/entity/generic/EntityImportContainer';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { translate } from 'react-i18next';

import RiderActions from 'common/redux/actions/rider';

import { getSalesChannels } from 'common/redux/selectors/clientSelector';

import { EntityImportHelper } from 'common/entity/helpers/EntityImportHelper';
import RiderImportHelper from 'common/entity/riderMaster/RiderImportHelper';
import PjpImportHelper from 'common/entity/helpers/PjpImportHelper';
import RiderMasterImportWorker from './workers/RiderMasterImportWorker';

import { RiderTypeType } from 'common/models/internal/MasterRider';
import { getPlatformSettings } from 'common/modules/platform-settings';

import RIDER_IMPORT_FORMAT from './tableConfig';

const ENTITY_NAME_ID = 'masterRider';

const mapStateToProps = (state, props) => {
    const { localeSettings } = getPlatformSettings();
    const salesChannels = getSalesChannels(state, props);
    const { currency } = localeSettings || {};

    return {
        defaultCurrency: currency,
        salesChannels,
        localeSettings
    };
};

const actions = {
    addEntities: RiderActions.addEntities,
    showSuccessMessage: RiderActions.showSuccessMessage
};

const EntityImportContainer = createEntityImportContainer({
    ImportWorker: RiderMasterImportWorker
});

class RiderMasterImportContainer extends React.PureComponent {
    getDefaultColumns(entitySettings) {
        const { t } = this.props;
        const customFields = RiderImportHelper.getCustomFields(entitySettings);

        return EntityImportHelper.getDefaultColumns({
            columns: RIDER_IMPORT_FORMAT,
            customFields,
            t,
            entityNameId: ENTITY_NAME_ID
        });
    }

    getTemplateRow(entitySettings) {
        const {
            t,
            defaultCurrency,
            salesChannels,
            localeSettings
        } = this.props;
        const customFields = RiderImportHelper.getCustomFields(entitySettings);
        return PjpImportHelper.setChannelsInTemplateRow(
            EntityImportHelper.getTemplateRow({
                columns: RIDER_IMPORT_FORMAT,
                customFields,
                t,
                entityNameId: ENTITY_NAME_ID,
                translationKeys: {
                    revenue: `{${defaultCurrency}}`,
                    type: RiderTypeType.values().join('/')
                },
                localeSettings
            }),
            salesChannels,
            t(`masterRiderProperties.pjpData.channel`)
        );
    }

    handleFinish = ({ entitiesToUpload, verifiedRowIds }) => {
        const { showSuccessMessage } = this.props;
        const verifiedExistingEntitiesSize = entitiesToUpload.filter(entity =>
            verifiedRowIds.includes(entity.id)
        ).size;
        const newEntitiesSize =
            entitiesToUpload.size - verifiedExistingEntitiesSize;

        if (newEntitiesSize) {
            showSuccessMessage?.(newEntitiesSize);
        }
    };

    render() {
        const { entitySettings } = this.props;

        return (
            <EntityImportContainer
                {...this.props}
                entityNameId={ENTITY_NAME_ID}
                generateEntityList={RiderImportHelper.generateEntityList}
                templateRowData={this.getTemplateRow(entitySettings)}
                defaultColumns={this.getDefaultColumns(entitySettings)}
                sanitizeBeforeUpload
                onFinish={this.handleFinish}
            />
        );
    }
}
export default compose(
    withRouter,
    connect(mapStateToProps, actions),
    translate('entityManagement')
)(RiderMasterImportContainer);
